import "./LandingTitle.scss";
import { motion } from "framer-motion";

const LandingTitle = ({ title, para, bgImage }) => {
  return (
    <section
      className="gallery_landing pt-5"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="content_wrap p_t p_b">
        <h2 className="pt-4 gold">
          {title
            ?.split("")
            .map((char, k) => (
              <motion.span
                initial={{ translateX: 24, opacity: 0 }}
                whileInView={{ translateX: 0, opacity: 1 }}
                transition={{
                  duration: 0.4,
                  ease: "easeInOut",
                  delay: 0.04 * k,
                }}
                key={k}
              >
                {char}
              </motion.span>
            ))
            .concat("")}
        </h2>
      {para && <p className="gold">{para}</p>}
      </div>
    </section>
  );
};

export default LandingTitle;
